import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Location } from "@angular/common";
import { MaskUtil } from 'src/app/utils/mask-util';
import { AdvogadoService } from 'src/app/service/advogado/advogado.service';
import { ToasterService } from 'angular2-toaster';
import { ResponseData } from 'src/app/model/response.data';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-esqueceu-senha-dialog',
  templateUrl: './esqueceu-senha-dialog.component.html',
  styleUrls: ['./esqueceu-senha-dialog.component.css']
})
export class EsqueceuSenhaDialogComponent implements OnInit {

  @BlockUI() blockUI : NgBlockUI;
  formGroup: FormGroup;
  finalizado: boolean = false;
  email: string = ''

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    private router : Router,
    private advogadoService: AdvogadoService,
    private toasterService: ToasterService,
    public dialogRef: MatDialogRef<EsqueceuSenhaDialogComponent>
  ) { }

  ngOnInit() {
    this.initFields();
  }

  initFields(): void {
    this.formGroup = this.formBuilder.group({
      inputCpf: new FormControl(null),
    });
  }


  async recuperarSenha() {
    if (this.formGroup.invalid) return;
    let cpf = this.formGroup.get("inputCpf").value;
    cpf = MaskUtil.maskToCpf(cpf);
    this.blockUI.start('Enviando...');

    const adovgadoJaCadastrado = await this.advogadoEstaCadastrado(cpf);
    if (adovgadoJaCadastrado) {
      this.advogadoService.recuperarSenha(cpf)
      .subscribe({
        next: (res: ResponseData<string>) => {
            this.email = res.data
            this.onSucess();
        },
        error: (_) => {
          this.blockUI.stop();
          this.toasterService.pop("warning", "Não foi possível gerar senha provisória, tente novamente mais tarde.");
        }
      });
    };
  }

  async advogadoEstaCadastrado(cpf: string) {
    try {
      await this.advogadoService.verificarExistenciaAdvogado(cpf, null).toPromise();
      this.informarCpfNaoEncontrado();
    } catch ({ status }) {
      if (status === 400) {
        return true;
      } else {
        this.blockUI.stop();
        this.toasterService.pop('warning', 'Ocorreu um erro, tente novamente em instantes.');
      }
      return true;
    }
  }

  informarCpfNaoEncontrado() {
    const inputControl = this.formGroup.get("inputCpf");
      inputControl.setErrors({
        userNotFound: true,
      });
    this.blockUI.stop();
    this.toasterService.pop('error', 'CPF não encontrado.');
  }


  onSucess() {
    this.blockUI.stop();
    this.finalizado = true;
  }

  onError() {    
    this.blockUI.stop();
    const inputControlCpf = this.formGroup.get("inputCpf");
    inputControlCpf.setErrors({
      userNotFound: true,
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  validarCpf() {
    const cpf = this.formGroup.get("inputCpf").value;
    const cpfValido = MaskUtil.validar_cpf(cpf);

    if (!cpfValido) {
      const inputControl = this.formGroup.get("inputCpf");
      inputControl.setErrors({
        invalidCpf: true,
      });
    }
  }

}
